'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _pure = require('recompose/pure');

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = require('../../SvgIcon');

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ImageFilterCenterFocus = function ImageFilterCenterFocus(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M5 15H3v4c0 1.1.9 2 2 2h4v-2H5v-4zM5 5h4V3H5c-1.1 0-2 .9-2 2v4h2V5zm14-2h-4v2h4v4h2V5c0-1.1-.9-2-2-2zm0 16h-4v2h4c1.1 0 2-.9 2-2v-4h-2v4zM12 9c-1.66 0-3 1.34-3 3s1.34 3 3 3 3-1.34 3-3-1.34-3-3-3z' })
  );
};
ImageFilterCenterFocus = (0, _pure2.default)(ImageFilterCenterFocus);
ImageFilterCenterFocus.displayName = 'ImageFilterCenterFocus';
ImageFilterCenterFocus.muiName = 'SvgIcon';

exports.default = ImageFilterCenterFocus;


//////////////////
// WEBPACK FOOTER
// ./~/material-ui/svg-icons/image/filter-center-focus.js
// module id = 2401
// module chunks = 0